import React from 'react'
import classNames from 'classnames'
import ProgressBar from './ProgressBar'
import ProgressCounter from './ProgressCounter'
import i18next from 'i18next'
import Loading from './Loading'
import QuestionnaireError from './smart/QuestionnaireErrorContainer'
import QuestionnaireThankYou from './QuestionnaireThankYou'

import styles from './styles/questionnaire.scss'
import illustration from './../assets/images/wopi-wide.png'

export default class WopiQuestions extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isHalfwaySkipped: false
    }
  }

  render() {
    const {
      questions,
      activeQuestionIndex,
      activeQuestionAnswer,
      language,
      refreshQuestionnaire
    } = this.props

    if (questions.count() == 0) {
      return <Loading />
    }

    if (activeQuestionIndex === questions.count()) {
      return (
        <QuestionnaireThankYou refreshQuestionnaire={refreshQuestionnaire} language={language} />
      )
    }

    if (activeQuestionIndex == questions.count() / 2 && !this.state.isHalfwaySkipped) {
      return this.renderHalfway(questions, activeQuestionIndex)
    }

    const question = questions.get(activeQuestionIndex)

    return (
      <section>
        <div className={styles.question}>
          <QuestionnaireError />

          <div className={classNames(styles.questionElement, styles.questionText)}>
            <p>{i18next.t(question.id, { lng: language, ns: 'questions' })}</p>
          </div>

          <div className={classNames(styles.questionElement, styles.questionAnswerButtons)}>
            <button
              id="true-button"
              key={question.id + 'y'}
              className={this.getClassNamesForButton(activeQuestionAnswer === true)}
              onClick={this.onAnswer(question.id, true)}
              disabled={activeQuestionAnswer !== null}
            >
              {i18next.t('true', { lng: language, ns: 'questionnaire' })}
            </button>

            <button
              id="false-button"
              key={question.id + 'n'}
              className={this.getClassNamesForButton(activeQuestionAnswer === false)}
              onClick={this.onAnswer(question.id, false)}
              disabled={activeQuestionAnswer !== null}
            >
              {i18next.t('false', { lng: language, ns: 'questionnaire' })}
            </button>
          </div>
        </div>

        <ProgressBar current={activeQuestionIndex + 1} max={questions.count()} />
        <ProgressCounter current={activeQuestionIndex + 1} max={questions.count()} />
      </section>
    )
  }

  onAnswer(questionId, answer = true) {
    return e => {
      e.preventDefault()

      this.props.onAnswer(
        this.props.uuid,
        this.props.questions,
        this.props.activeQuestionIndex,
        questionId,
        answer
      )
    }
  }

  renderHalfway(questions, activeQuestionIndex) {
    return (
      <section className={styles.introductionText}>
        <h1>{i18next.t('halfway', { lng: this.props.language, ns: 'questionnaire' })}</h1>

        <p>
          <button
            className={styles.button}
            onClick={() => this.setState({ isHalfwaySkipped: true })}
          >
            {i18next.t('continue', { lng: this.props.language, ns: 'questionnaire' })}
          </button>
        </p>

        <p>
          <img className={styles.illustration} src={illustration} />
        </p>

        <ProgressBar current={activeQuestionIndex} max={questions.count()} />
        <ProgressCounter current={activeQuestionIndex} max={questions.count()} />
      </section>
    )
  }

  getClassNamesForButton(isAnswered) {
    if (isAnswered) {
      return classNames(styles.button, styles.isAnswered)
    }

    return styles.button
  }
}



// WEBPACK FOOTER //
// ./src/components/WopiQuestions.js